// eslint-disable-next-line no-restricted-imports
export * from '@mui/monorepo/docs/config';
